import {Grid, GridCellProps, GridColumn} from "@progress/kendo-react-grid"
import {BookingCountDetail} from "../../containers/Dashboard/dashboardSlice"
import {RootState} from "../../rootReducer"
import {SpinnerGrid} from "../../shared/CommonItems"
import {useAppSelector} from "../../store"

const BookingInfoCard = () => {
    const bookingCountDetail = useAppSelector((state: RootState) => state.containers.dashboard.bookingCountDetail)
    const isLoadingBookingCount = useAppSelector((state: RootState) => state.containers.dashboard.isLoadingBookingCount)

    const CustomColumnCell = (props: GridCellProps) => (
        <td className="text-sm-end">{props.dataItem[`${props.field}`]}</td>
    )

    const GridHeaderCell = (props: any) => (
        <a>
            <span title={props.title}>{props.title}</span>
        </a>
    )
    const CustomMainCell = (props: GridCellProps) => (
        <td className="text-sm-start">{props.dataItem[`${props.field}`]}</td>
    )
    return (
        <>
            {isLoadingBookingCount && <SpinnerGrid />}
            <Grid
                className="p-0"
                style={{height: "100%"}}
                data={bookingCountDetail
                    .map((DbItem: BookingCountDetail) => Object.assign(DbItem))
                    .map(item => ({
                        ...item,
                    }))}
                scrollable={"scrollable"}
            >
                <GridColumn
                    headerClassName="text-end"
                    field="specification"
                    title=" "
                    width="180px"
                    cell={CustomMainCell}
                />
                <GridColumn
                    headerClassName="text-end"
                    field="daily"
                    title="Today"
                    headerCell={GridHeaderCell}
                    cell={CustomColumnCell}
                />
                <GridColumn
                    headerClassName="text-end"
                    field="weekly"
                    title="This Week"
                    headerCell={GridHeaderCell}
                    cell={CustomColumnCell}
                />
                <GridColumn
                    headerClassName="text-end"
                    field="monthly"
                    title="This Month"
                    headerCell={GridHeaderCell}
                    cell={CustomColumnCell}
                />
            </Grid>
        </>
    )
}

export default BookingInfoCard
